import { render, staticRenderFns } from "./stock-data-empty.vue?vue&type=template&id=b525d714&lang=pug"
import script from "./stock-data-empty.vue?vue&type=script&lang=js"
export * from "./stock-data-empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports